import React, {useEffect, useState} from 'react';
import {ISlideStream} from 'shared/collections/SlideStream';
import SlideshowPage from 'client/components/slideshow/SlideshowPage';
import getCurrentSlideshowNumId from './getCurrentSlideshowNumId';

const UPDATE_INTERVAL_IN_MS = 30000;

interface ISlideStreamWrapperProps {
	slideStream: ISlideStream;
}

const SlideStreamWrapper: React.FC<ISlideStreamWrapperProps> = ({slideStream}) => {
	const [currentSlideshowNumId, setCurrentSlideshowNumId] = useState(
		getCurrentSlideshowNumId(slideStream),
	);

	useEffect(() => {
		const updateTimer = setInterval(() => {
			const newNumId = getCurrentSlideshowNumId(slideStream);

			setCurrentSlideshowNumId((currentValue) => {
				if (newNumId === currentValue) return currentValue;
				return newNumId;
			});
		}, UPDATE_INTERVAL_IN_MS);

		return () => {
			clearInterval(updateTimer);
		};
	}, [slideStream]);

	if (!currentSlideshowNumId) {
		return <div>В потоке нет слайдов на данный момент.</div>;
	}

	return <SlideshowPage slideNumId={currentSlideshowNumId} />;
};

export default SlideStreamWrapper;
